import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

export interface IGetAccommodationCategory {
  id?: number;
  category_id?: number;
}

export interface IPostAccommodationCategory {
  title: string;
}

export interface IPutAccommodationCategory {
  id: number;
  title: string;
}

// GET Accommodation Categories
export async function GetAccommodationCategories(params: IGetAccommodationCategory, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/category"), params, useGlobalLoader);
}

// POST Accommodation Categories
export async function PostAccommodationCategory(params: IPostAccommodationCategory, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/category"), params, useGlobalLoader);
}

// PUT Accommodation Categories
export async function PutAccommodationCategory(params: IPutAccommodationCategory, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit/category"), params, useGlobalLoader);
}
